<template>
  <div class="box5">
    <pageTitle
      title="博学谷&nbsp;&nbsp;重点培养AI两大关键能力"
      text="制定AI培训新标准，培养AI专精型人才"
    />

    <div class="subject-content">
      <div class="demo-box">
        <div class="tag">博学谷</div>
        <div class="demo demo1">
          <div class="title">AI算法深入研究能力</div>
          <p>
            以算法实用性、先进性、可拓展性， 让学生掌握算法模型举一反三的技能
          </p>
          <img src="../../../assets/coursePage/ai/box5/icon1.png" alt />
        </div>
        <div class="line"></div>
        <div class="demo" style="margin-top: 0.426667rem">
          <div class="title">AI算法业务流处理能力</div>
          <p>
            通过企业实战场景、业务流，对AI技术实战训练，解决实战业务流问题。
          </p>
          <img
            style="top: 0.373333rem"
            src="../../../assets/coursePage/ai/box5/icon2.png"
            alt
          />
        </div>
      </div>

      <div class="demo-box demo-box2">
        <div class="tag">其他机构</div>
        <div class="demo">
          <div class="title">基础能力</div>
          <p>
            使用部分Python开发、大数据处理、 数据分析内容，充当人工智能课程。
          </p>
          <img src="../../../assets/coursePage/ai/box5/icon3.png" alt />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import pageTitle from "../common/pageTitle.vue";
export default {
  components: {
    pageTitle,
  },
  mounted() {},
  data() {
    return {};
  },
  methods: {},
};
</script>

<style lang="less" scoped>
.box5 {
  padding: 80px 0 88px;
  width: 100%;
  background: linear-gradient(
    360deg,
    rgba(245, 255, 255, 0) 0%,
    rgba(221, 243, 255, 0.36) 100%
  );
  .subject-content {
    margin-top: 80px;
    .demo-box {
      position: relative;
      margin: 0 auto;
      padding: 64px 80px 48px 80px;
      width: 686px;
      background-color: #dff2fe;
      background-image: url("../../../assets/coursePage/ai/box5/bg1.png");
      background-repeat: no-repeat;
      background-size: cover;
      border-radius: 20px;
      box-sizing: border-box;
    }

    .demo-box2 {
      margin-top: 80px;
      background-image: url("../../../assets/coursePage/ai/box5/bg2.png");
      background-size: cover;
      background-repeat: no-repeat;
      .tag {
        background: url("../../../assets/coursePage/ai/box5/tag2.png") no-repeat;
        background-size: cover;
        color: #8db8d2;
      }
    }
    .tag {
      position: absolute;
      left: 0;
      top: -32px;
      width: 180px;
      height: 80px;
      background: url("../../../assets/coursePage/ai/box5/tag1.png") no-repeat;
      background-size: cover;
      text-align: center;
      font-size: 28px;
      font-family: PingFangSC-Medium;
      font-weight: 500;
      color: #ffffff;
      line-height: 60px;
    }

    .demo {
      position: relative;

      img {
        position: absolute;
        top: -4px;
        right: 0px;
        height: 124px;
        height: 88px;
      }
      .title {
        position: relative;
        margin-bottom: 28px;
        font-size: 28px;
        font-family: PingFangSC-Medium;
        font-weight: 500;
        color: #1d2129;
        line-height: 40px;
        &::after {
          content: "";
          position: absolute;
          left: 0px;
          bottom: -12px;
          width: 40px;
          height: 4px;
          background: #0f9df1;
          border-radius: 2px;
        }
      }

      p {
        font-size: 24px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #1d2129;
        line-height: 44px;
      }
    }

    .demo1 {
      margin-bottom: 32px;
    }

    .line {
      width: 100%;

      height: 1px;
      background: -webkit-linear-gradient(
        left,
        #d1eeff -4%,
        #fff 50%,
        #e6f6ff 100%
      );
    }
  }
}
</style>
